import { render, staticRenderFns } from "./ManageAdd.vue?vue&type=template&id=457e6945&scoped=true&"
import script from "./ManageAdd.vue?vue&type=script&lang=js&"
export * from "./ManageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e6945",
  null
  
)

export default component.exports